import { useOutletContext } from 'react-router-dom';
import type { HubOutletContext } from '../EnterpriseHub';
import { resolveScenario } from '../../lib/resolveScenario';
import {
  AdminOnlyScenario,
  MultiAppScenario,
  NoEntitlementScenario,
  SingleAppRedirect,
} from './scenarios';

// The data picks the landing state — one hub route, no manual scenario picker.
// While /me is loading or errored there are no sections yet; MultiAppScenario
// already renders both of those states, so it hosts them here too.
export function ResolvedScenario() {
  const { sections, isOrgAdmin, roles } = useOutletContext<HubOutletContext>();
  if (!sections) return <MultiAppScenario />;

  switch (resolveScenario(sections, isOrgAdmin, roles)) {
    case 'no-entitlement':
      return <NoEntitlementScenario />;
    case 'admin-only':
      return <AdminOnlyScenario />;
    case 'single-app':
      return <SingleAppRedirect />;
    default:
      return <MultiAppScenario />;
  }
}
